import { h } from '@/lib/dom';
import { mountSingleLineChart } from '@/components/SingleLineChart';
import { WINDOW_LABELS } from '@/lib/format';
import type { WindowKey } from '@/lib/format';

export interface ChartSpec {
  title: string;
  unit: string;
  xs: number[];
  values: Array<number | null>;
  fractionDigits: number;
}

export function buildChartCard(spec: ChartSpec, window: WindowKey): HTMLElement {
  const area = h('div', {
    class: 'sleep-chart-area',
    role: 'img',
    aria: { label: `${spec.title} за ${WINDOW_LABELS[window]}` },
  });

  const hasData = spec.values.some((v) => v != null);
  if (!hasData) {
    area.appendChild(h('div', { class: 'empty-state' }, 'Нет данных в окне.'));
  } else {
    queueMicrotask(() => {
      void mountSingleLineChart({
        area,
        xs: spec.xs,
        values: spec.values,
        label: spec.title,
        unit: spec.unit,
        fractionDigits: spec.fractionDigits,
      });
    });
  }

  return h('div', { class: 'sleep-chart-card' }, [
    h('div', { class: 'sleep-chart-title' }, [
      h('span', null, spec.title),
      h('span', { class: 'sleep-chart-axis' }, spec.unit),
    ]),
    area,
  ]);
}

export function chartsSection(specs: ChartSpec[], window: WindowKey): HTMLElement {
  const grid = h('div', { class: 'sleep-charts-grid' });
  for (const spec of specs) {
    grid.appendChild(buildChartCard(spec, window));
  }

  return h('section', { class: 'sleep-section' }, [
    h('h2', { class: 'sleep-section-header' }, [
      h('span', null, 'Графики'),
      h('span', { class: 'sleep-section-meta' }, 'пунктир — линия тренда'),
    ]),
    grid,
  ]);
}
